import { StandardEntity } from '@infodata-group/inf-commons';
import { VehicleMaintenanceDto } from '../interface/vehicle-maintenance.dto';

export class VehicleMaintenance extends StandardEntity {
  public date: string;
  public kms: number;
  public hours: number;
  public description: [string];
  public status: string;
  get stateFormater(): string {
    return this.status === 'effectue' ? 'Effectué' : 'À venir';
  }
  public action: string;
  public daysReminder: number;
  public kmsReminder: number;
  public hoursReminder: number;

  public override serialize(): VehicleMaintenanceDto {
    return {
      id: this.id,
      date: this.date,
      kms: this.kms,
      hours: this.hours,
      description: this.description,
      daysReminder: this.daysReminder,
      kmsReminder: this.kmsReminder,
      hoursReminder: this.hoursReminder,
      status: this.status,
      action: this.action,
    };
  }
}
